export default __webpack_public_path__ + "static/grey-desserto-sand-6c732d7e2bd90b162e5001a58b4136ef.jpg";